module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "login",
    attrs: {
      "id": "login",
      "data-role": "page"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "wxid",
      "name": "wx_id",
      "value": "${wxid!}"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "referer",
      "value": "${referer!}"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weui_cells weui_cells_access"
  }, [_c('div', {
    staticClass: "weui_cell login_box_line"
  }, [_c('div', {
    staticClass: "weui_cell_bd weui_cell_primary"
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.username),
      expression: "username",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_name",
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "weui_cell login_box_line"
  }, [_c('div', {
    staticClass: "weui_cell_bd weui_cell_primary"
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_name",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn_log"
  }, [_c('button', {
    class: [{
      'weui-btn_disabled': false
    }, 'weui-btn weui-btn_primary'],
    on: {
      "click": _vm.loginaa
    }
  }, [_vm._v("登录")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showtip),
      expression: "showtip"
    }],
    staticClass: "js_dialog"
  }, [_c('div', {
    staticClass: "weui-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._v(_vm._s(_vm.tipContent))]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("关闭")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoginLoading),
      expression: "showLoginLoading"
    }],
    staticClass: "list_loadingToast"
  }, [_c('div', {
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd tx-c"
  }, [_c('h2', [_vm._v("合同管理系统")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v("登陆出错")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-toast"
  }, [_c('i', {
    staticClass: "weui-loading weui-icon_toast"
  }), _vm._v(" "), _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v("登录中...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59840999!./~/vue-loader/lib/selector.js?type=template&index=0!./src/login.vue
// module id = 143
// module chunks = 2